import type { AppDispatch } from '@/store/store';

import { useGetLoggedInUser } from '@/api/webappApi';
import { setUser } from '@/store/reducerUser';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export function AuthInitializer() {
  const dispatch = useDispatch<AppDispatch>();
  const { data } = useGetLoggedInUser();

  useEffect(() => {
    if (data) {
      dispatch(setUser(data));
    }
  }, [data, dispatch]);

  return null;
}
